import { useRef, useState } from "react";
import { MoveHorizontal } from "lucide-react";

export default function BeforeAfter({ before, after, labelBefore, labelAfter }) {
  const [pos, setPos] = useState(50);
  const ref = useRef(null);

  const move = (clientX) => {
    const rect = ref.current.getBoundingClientRect();
    let p = ((clientX - rect.left) / rect.width) * 100;
    p = Math.max(0, Math.min(100, p));
    setPos(p);
  };

  return (
    <div
      ref={ref}
      data-testid="before-after-slider"
      className="relative w-full aspect-[4/3] overflow-hidden select-none border border-slate-200 cursor-ew-resize"
      onMouseMove={(e) => e.buttons === 1 && move(e.clientX)}
      onClick={(e) => move(e.clientX)}
      onTouchMove={(e) => move(e.touches[0].clientX)}
    >
      <img src={after} alt="after" className="absolute inset-0 w-full h-full object-cover" draggable="false" />
      <span className="absolute top-3 right-3 bg-brand text-white text-xs font-semibold uppercase tracking-wider px-2.5 py-1">{labelAfter}</span>
      <div className="absolute inset-0 overflow-hidden" style={{ width: `${pos}%` }}>
        <img src={before} alt="before" className="absolute inset-0 h-full object-cover max-w-none" style={{ width: ref.current ? ref.current.offsetWidth : "100%" }} draggable="false" />
        <span className="absolute top-3 left-3 bg-white text-brand text-xs font-semibold uppercase tracking-wider px-2.5 py-1">{labelBefore}</span>
      </div>
      <div className="absolute top-0 bottom-0 w-0.5 bg-white" style={{ left: `${pos}%` }}>
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-10 h-10 bg-white grid place-items-center shadow-lg">
          <MoveHorizontal size={18} className="text-brand" />
        </div>
      </div>
    </div>
  );
}
